import { NavLink } from "react-router-dom";
import { FileText, Wrench } from "lucide-react";

/** Segmented toggle shown at the top of both "My Leads" (new requests) and
 * "Service Requests" so switching between the two is obvious and intuitive. */
export default function ScRequestTypeToggle({ active }) {
  return (
    <div className="flex items-center gap-1 bg-slate-100 p-1 rounded-xl mb-3" data-testid="sc-request-type-toggle">
      <NavLink
        to="/sc/leads"
        data-testid="sc-toggle-new-requests"
        className={
          "flex-1 flex items-center justify-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider py-2 rounded-lg transition-all " +
          (active === "leads" ? "bg-white text-[#1B5E20] shadow-sm" : "text-slate-500 hover:text-slate-700")
        }
      >
        <FileText className="w-3.5 h-3.5" /> New Installations
      </NavLink>
      <NavLink
        to="/sc/service-requests"
        data-testid="sc-toggle-service-requests"
        className={
          "flex-1 flex items-center justify-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider py-2 rounded-lg transition-all " +
          (active === "service" ? "bg-white text-[#1B5E20] shadow-sm" : "text-slate-500 hover:text-slate-700")
        }
      >
        <Wrench className="w-3.5 h-3.5" /> Service Requests
      </NavLink>
    </div>
  );
}
